import { render, staticRenderFns } from "./generalCarousel.vue?vue&type=template&id=03d60230&"
import script from "./generalCarousel.vue?vue&type=script&lang=js&"
export * from "./generalCarousel.vue?vue&type=script&lang=js&"
import style0 from "./generalCarousel.vue?vue&type=style&index=0&id=03d60230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports